export enum ExitReasonsEnum{
    POOR_HEALTH = 'POOR HEALTH',
    WORK_ENVIRONMENT = 'WORK ENVIRONMENT',
    LACK_OF_CAREER_GROWTH = 'LACK OF CAREER GROWTH',    
    NEED_FOR_HIGH_SALARY= 'NEED FOR HIGH SALARY',
    CHANGE_OF_CITY = 'CHANGE OF CITY',
    FAMILY_REASONS = 'FAMILY REASONS'
}